import React from 'react';
import bindAll from 'lodash.bindall';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import C3ProjectList from './c3-project-list.jsx';
import C3Error from './c3-error.jsx';
import queryString from 'query-string';
import c3Storage, {moveToNewProjectPage} from '../../lib/c3/c3-storage.js';
import c3Auth from '../../lib/c3/c3-auth.js';
import C3ShareToken from '../../lib/c3/c3-share-token.jsx';
import C3Api from '../../lib/c3/c3-api.js';
import { isDevelopment } from '../../lib/c3/utils/common.js';
import { err500 } from '../../lib/c3/c3-error';
import c3User from '../../lib/c3/c3-user.js';
import ContinueModal from './continue-modal/continue-modal.jsx';
import { START_PARAMS } from '../../lib/c3/constants/constants.js';

class C3GuiWrapper extends React.Component {
    constructor (props) {
        super(props);
        this._unmounted = false;
        this.state = {
            initialized: false,
            showContinueModal: false,
            missionId: null,
            existingProjectId: null,
        };
        bindAll(this, [
            'handleContinue',
            'handleNew',
        ]);
    }

    componentDidMount() {
        this.initialize();
    }

    componentWillUnmount() {
        this._unmounted = true;
    }

    initialize () {
        const queryParams = queryString.parse(location.search);

        if (queryParams.projectId) {
            c3Storage.loadProject(queryParams.projectId, false).then(()=>{
                if (!this._unmounted) {
                    this.setState({
                        initialized: true,
                    })
                }
            })
            return
        }

        // 共有されたプロジェクトを開く場合
        if (queryParams.token) {
            const [userId, projectId] = C3ShareToken.decode(queryParams.token)
            // 共有されたユーザのIDで上書きする
            c3Storage.setUserId(userId)
            c3Storage.loadProject(projectId, true).then(()=>{
                if (!this._unmounted) {
                    this.setState({
                        initialized: true,
                    })
                }
            })
            return
        }

        // 既存プロジェクトを開くまたは新規作成する
        let missionId = null;
        let start = START_PARAMS.INIT; // デフォルトは 'init'
        if (this.props.params) {
            missionId = this.props.params.missionId;
            start = this.props.params.start || START_PARAMS.INIT;
        } else if ( isDevelopment() ) {
            missionId = window.prompt("ミッションIDを入力する", "");
        }
        if (!missionId) {
            err500();
            return;
        }

        // start パラメータによる処理の分岐
        // - パラメータなし または start=init → 常に新規作成
        // - start=continue → 既存があれば開く、なければ新規作成
        // - start=confirm → モーダルで確認

        if (start === START_PARAMS.INIT) {
            // 常に新規プロジェクトを作成
            this.createAndMoveToProject(missionId);
        } else if (start === START_PARAMS.CONFIRM) {
            // 既存プロジェクトがあればモーダルで確認、なければ新規作成
            c3Storage.findProjectByMissionId(missionId)
                .then(existingProjectId => {
                    if (existingProjectId && !this._unmounted) {
                        // 既存プロジェクトがあればモーダルを表示
                        this.setState({ showContinueModal: true, missionId: missionId, existingProjectId: existingProjectId });
                    } else {
                        // なければ新規作成
                        this.createAndMoveToProject(missionId);
                    }
                })
                .catch(() => {
                    err500();
                });
        } else if (start === START_PARAMS.CONTINUE) {
            // 既存があれば開く、なければ新規作成
            this.openExistingOrCreateProject(missionId);
        } else {
            // 不明なパラメータの場合は新規作成（後方互換性のため）
            this.createAndMoveToProject(missionId);
        }
    }

    handleContinue() {
        moveToNewProjectPage(this.state.existingProjectId);
    }

    handleNew() {
        this.createAndMoveToProject(this.state.missionId);
    }

    openExistingOrCreateProject (missionId) {
        // 既存プロジェクトがあれば開く、なければ新規作成
        c3Storage.findProjectByMissionId(missionId)
            .then(existingProjectId => {
                if (existingProjectId) {
                    moveToNewProjectPage(existingProjectId);
                } else {
                    this.createAndMoveToProject(missionId);
                }
            })
            .catch(() => {
                err500();
            });
    }

    createAndMoveToProject (missionId) {
        // missionIdからtitleとipを取得
        C3Api.fetchMissionInfo(missionId)
            .then(missionData => {
                return c3Storage.createNewProject(
                    c3Storage.userId(),
                    missionId,
                    missionData.title,
                    missionData.ip
                );
            })
            .then(projectId => {
                moveToNewProjectPage(projectId);
            })
            .catch(() => {
                err500();
            })
    }

    render() {
        if (this.state.showContinueModal) {
            return (
                <ContinueModal
                    onContinue={this.handleContinue}
                    onNew={this.handleNew}
                />
            );
        }
        
        return this.state.initialized && this.props.children;
    }
}

class Signout extends React.Component {
    componentWillMount () {
        isDevelopment() && c3Auth.signOut()
    }

    render() {
        return null
    }
}

class C3Wrapper extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'initialize',
        ]);
        this.state = {
            initialized: false,
            params: null,
        };
    }

    componentWillMount () {
        c3Storage.initialize(process.env.FIREBASE_CONFIG)
        c3Auth.initialize(process.env.FIREBASE_CONFIG)
        c3User.initialize(process.env.FIREBASE_CONFIG)
        const queryParams = queryString.parse(location.search)
        if (queryParams.q) {
            C3Api.acquireParameter(queryParams.q)
                .then((params) => {
                    this.setState({
                        ...this.state,
                        params: params
                    })
                    c3Auth.authenticate(params.user, params.fb).then(this.initialize);
                })
            return
        }

        c3Auth.currentStatus().then(user => {
            //ログイン状態なら、そのユーザーのまま共有作品をひらく
            //token がない場合は、有効なログイン情報がないと開けない
            if (user?.uid || !queryParams.token) {
              c3Auth.authenticate().then(this.initialize);
            //ログインユーザーがなく、token パラメータがあれば、ゲストユーザーでログイン
            } else if (queryParams.token) {
              c3Auth.authenticate(c3User.guestUser().email, c3User.guestUser().password).then(this.initialize);
            }
        });
    }

    initialize (userId) {
        c3Storage.setUserId(userId)
        //管理者ユーザーでログインしていれば管理者フラグをセット
        c3Storage.setIsAdmin(userId);
        c3User.setUserId(userId)
        this.setState({
            ...this.state,
            initialized: true
        })
    }

    render() {
        return this.state.initialized && (
            <BrowserRouter>
                <Switch>
                    <Route exact path='/'>
                        <C3GuiWrapper params={this.state.params}>{this.props.children}</C3GuiWrapper>
                    </Route>
                    <Route exact path='/projects' component={C3ProjectList} />
                    <Route exact path='/signout' component={Signout} />
                    <Route exact path='/error' component={C3Error} />
                </Switch>
            </BrowserRouter>
        )
    }
}

export default C3Wrapper
